var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimeSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_time_search",
    d: "M19.238,4a15.238,15.238,0,1,0,4.491,29.8,7.627,7.627,0,0,1-2.467-1.783A13.057,13.057,0,1,1,32.017,21.262,7.62,7.62,0,0,1,33.8,23.729,15.238,15.238,0,0,0,19.238,4Zm.363,6.079a1.143,1.143,0,0,0-1.125,1.159v8H13.524a1.143,1.143,0,1,0,0,2.286h6.1a1.143,1.143,0,0,0,1.143-1.143V11.238A1.143,1.143,0,0,0,19.6,10.079Zm7.256,10.683A6.1,6.1,0,1,0,30.28,31.9l3.769,3.769a1.143,1.143,0,0,0,1.616-1.616L31.9,30.28a6.092,6.092,0,0,0-5.04-9.518Zm0,2.286a3.81,3.81,0,1,1-3.81,3.81A3.814,3.814,0,0,1,26.858,23.048Z",
    transform: "translate(-4 -4)",
    fill: "#d5763f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeSearch);
export default __webpack_public_path__ + "static/media/iconTimeSearch.117f0cf57ff7ca08c9692e1eed285e59.svg";
export { ForwardRef as ReactComponent };